// 用户
const Statistics = () => import('@/views/user/Statistics')
const Login = () => import('@/views/user/Login')
const Customer = () => import('@/views/user/Customer')
const Password = () => import('@/views/user/Password')
const Coupon = () => import('@/views/user/Coupon')
const Register = () => import('@/views/user/Register')

export default [
  {
    path: '/user/statistics',
    component: Statistics,
    meta: {
      title: '数据统计'
    }
  },
  {
    path: '/user/login',
    component: Login,
    meta: {
      title: '登录',
      ignoreBackTop: true
    }
  },
  // {
  //   path: '/user/customer',
  //   component: Customer,
  //   meta: {
  //     title: '我的客户'
  //   }
  // },
  {
    path: '/user/password',
    component: Password,
    meta: {
      title: '修改密码'
    }
  },
  {
    path: '/user/coupon',
    component: Coupon,
    meta: {
      title: '优惠券'
    }
  },
  {
    path: '/user/register',
    component: Register,
    meta: {
      title: '填写信息'
    }
  }
]



// WEBPACK FOOTER //
// ./src/router/user.js